import { Fragment } from "react";
import { Check, Minus } from "lucide-react";

const ROWS = [
  { f: "Cek ketahanan keuangan (±2 menit, tanpa akun)", free: true },
  { f: "Skor dasar: dana darurat, risiko runtuh, ruang gerak", free: true },
  { f: "3 rekomendasi prioritas pertama", free: true },
  { f: "Data 100% privat — angka tidak dikirim ke server", free: true },
  { f: "Jurnal pemasukan & pengeluaran harian", free: false },
  { f: "Kesehatan Harian (skor A–E) + peringatan otomatis", free: false },
  { f: "Sisa budget & forecast saldo akhir bulan", free: false },
  { f: "Ringkasan mingguan & bulanan + tren 6 bulan", free: false },
  { f: "Target hemat & progres", free: false },
  { f: "Family Survival Runway + stress test interaktif", free: false },
  { f: "Simulasi “Bagaimana Jika”", free: false },
  { f: "Ekspor PDF insight", free: false },
  { f: "Komunitas Premium + diskusi expert finance", free: false },
  { f: "Backup & restore terenkripsi lintas perangkat", free: false },
];

export function CompareTable() {
  return (
    <div className="overflow-hidden rounded-3xl border border-zinc-200 bg-white" data-testid="compare-table">
      <div className="grid grid-cols-[1fr_72px_88px] sm:grid-cols-[1fr_96px_120px]">
        <div className="px-4 py-3" />
        <div className="flex items-center justify-center px-2 py-3 font-heading text-xs font-bold text-zinc-500">Gratis</div>
        <div className="flex items-center justify-center bg-emerald-600 px-2 py-3 font-heading text-xs font-bold text-white">Premium</div>
        {ROWS.map((r, i) => (
          <Fragment key={r.f}>
            <div className="border-t border-zinc-100 px-4 py-2.5 text-xs leading-snug text-zinc-700">{r.f}</div>
            <div className="flex items-center justify-center border-t border-zinc-100 px-2 py-2.5" data-testid={`cmp-free-${i}`}>
              {r.free ? <Check className="h-4 w-4 text-emerald-600" /> : <Minus className="h-4 w-4 text-zinc-300" />}
            </div>
            <div className="flex items-center justify-center border-t border-zinc-100 bg-emerald-50/60 px-2 py-2.5" data-testid={`cmp-pro-${i}`}>
              <Check className="h-4 w-4 text-emerald-600" />
            </div>
          </Fragment>
        ))}
      </div>
    </div>
  );
}
